<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)" v-for="item in items" :updateMouseHovered="updateMouseHovered" :key="item.header || item.title" :item="item"
      :is-updated="isUpdated"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from 'vue'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    updateMouseHovered: {
      type: Function,
      required: true,
    },
  },
  setup() {
    provide('openGroups', ref([]))

    return {
      resolveNavItemComponent,
    }
  },
  data() {
    return {
      isUpdated: false,
    }
  },
  watch: {
    items: {
      handler(value) {
        if (value) this.isUpdated = !this.isUpdated
      },
    },
  },
}
</script>
